import {TweenMax, TimelineMax} from 'gsap';
import Utils from '../../../../viscomjs/utils/utils';
import {Factory as StoriesFactory} from './StoriesFactory';

const EventEmitter = require('eventemitter3');

//

//
// INTERNAL FUNCTIONS:
//
const _mount = (Decoration, el) => {
    el.appendChild(Decoration.domElement);
};

const _remove = Decoration => {
    if (!Decoration.domElement || !Decoration.domElement.parentNode) return;
    Decoration.domElement.parentNode.removeChild(Decoration.domElement);
};

const _reset = Decoration => {
    Decoration.lastS = -1;
};

const _construct = Decoration => {
    // Construct canvas, stage and MovieClip with graph
    const obj = Decoration.factory(Decoration.params.id);

    Decoration.refWidth = obj.pack.getWidth();
    Decoration.refHeight = obj.pack.getHeight();

    // Decoration.ticker.fps(obj.pack.getFPS());

    Decoration.app = obj.app;
    Decoration.mc = obj.mainView;
    Decoration.stage = obj.stage;
    Decoration.domElement = obj.domElement;
    Decoration.resizeMainView = obj.resizeMainView;
    Decoration.resizeCanvas = obj.resizeCanvas;
    Decoration.renderView = obj.render;
    Decoration.resetAnimation = obj.pack.reset;
    Decoration.setShowAnimation = obj.pack.setShowAnimation;
    Decoration.setHideAnimation = obj.pack.setHideAnimation;
    Decoration.setOpenAnimation = obj.pack.setOpenAnimation;
    Decoration.setCloseAnimation = obj.pack.setCloseAnimation;

    Decoration.resetAnimation(Decoration.mc);
};

//

//
// INTERNAL METHODS FUNCTIONS:
//
const _onResize = function() {
    //
    const rect = this.el.getBoundingClientRect();
    const cRect = this.centerEl.getBoundingClientRect();
    this.width = rect.width;
    this.height = rect.height;

    if (this.height < 1 || this.width < 1) return;

    const w = this.refWidth,
        h = this.refHeight;
    const iw = this.width,
        ih = this.height;
    const xRatio = iw / w,
        yRatio = ih / h,
        sRatio = Math.min(xRatio, yRatio);

    if (this.lastS === sRatio) return;

    this.centerX0 = sRatio * (w / 2 - 750 - 20);
    this.centerX1 = rect.left + rect.width / 2 - cRect.left - cRect.width / 2;
    this.centerX = this.centerX0 - this.centerX1;
    this.centerY0 = sRatio * (h / 2 - 620);
    this.centerY1 = rect.top + rect.height / 2 - cRect.top - cRect.height / 2;
    this.centerY = this.centerY0 - this.centerY1;

    this.resizeMainView(this.mc, w, h, this.centerX / sRatio, this.centerY / sRatio);
    this.resizeCanvas(iw, ih);

    this.lastS = sRatio;
};

// _render: render only
//
const _render = function(dt) {
    this.renderView(dt);
};

const _onStartTransition = Decoration => {
    Decoration.transition = true;
    Decoration.emit('startTransition');
};

const _onStopTransition = Decoration => {
    if (Decoration._tl) {
        Decoration._tl.kill();
    }
    Decoration._tl = null;
    Decoration.transition = false;
    Decoration.emit('endTransition');
};

//

//
// INTERFACE METHODS FUNCTIONS:
//
const init = (Decoration, el, centerEl) => {
    if (Decoration.initiated) return Decoration;

    Decoration.el = el;
    Decoration.centerEl = centerEl || el;

    // Initial size
    const rect = Decoration.el.getBoundingClientRect();
    Decoration.width = rect.width;
    Decoration.height = rect.height;

    _construct(Decoration);

    // SET INTERNAL METHODS:
    Decoration._onResize = _onResize.bind(Decoration);
    Decoration._render = _render.bind(Decoration);

    Decoration._onResize();
    Decoration.setState(Decoration.stateName);

    // Add listeners
    Decoration.win.addEventListener('resize', Decoration._onResize);

    // Mount
    _mount(Decoration, el);
    // _forceInitialRender(Decoration);

    Decoration.initiated = true;

    return Decoration;
};

const destroy = Decoration => {
    if (!Decoration.initiated) return Decoration;

    Decoration.stop();

    Decoration.removeAllListeners();

    Decoration.win.removeEventListener('resize', Decoration._onResize);
    _remove(Decoration);
    _reset(Decoration);

    delete Decoration.domElement;
    delete Decoration.mc;

    delete Decoration._onResize;
    delete Decoration._render;

    Decoration.initiated = false;

    return Decoration;
};

const start = Decoration => {
    if (!Decoration.initiated || Decoration.started) return Decoration;

    Decoration._needForceInvalidate = true;
    Decoration.started = true;
    Decoration.render();
    Decoration.ticker.addEventListener('tick', Decoration.render);

    return Decoration;
};

const stop = Decoration => {
    if (!Decoration.initiated || !Decoration.started) return Decoration;

    Decoration.started = false;
    Decoration.ticker.removeEventListener('tick', Decoration.render);

    return Decoration;
};

const render = (Decoration, dt) => {
    if (!Decoration.initiated) return Decoration;
    Decoration._render(dt);
    return Decoration;
};

const setState = function(stateName) {
    if (this.stateName === stateName) return this;

    this.prevStateName = this.stateName;
    this.stateName = stateName;

    // console.log(this.prevStateName, 'to', stateName);

    if (!this.initiated) return this;

    if (this._tl) {
        this._tl.kill();
        this._tl = null;
    }
    // Timeline for repeating animation
    if (this._tl2) {
        this._tl2.paused(true);
    }

    // ANIMATE:

    const tl = new TimelineMax({
        // paused: true,
        /* onUpdate: d => {
            console.log(d.mc.vs.x);
        },
        onUpdateParams: [this],*/
        onComplete: d => {
            _onStopTransition(d);
            d._tl = null;

            if (d.stateName === 'hidden' && d._tl2) {
                d._tl2.kill();
                d._tl2 = null;
            }
        },
        onCompleteParams: [this],
        onReverseComplete: d => {
            _onStopTransition(d);
            d._tl = null;

            if (d.stateName === 'hidden' && d._tl2) {
                d._tl2.kill();
                d._tl2 = null;
            }
        },
        onReverseCompleteParams: [this]
    });

    const tl2 = new TimelineMax();

    // Add transition to timeline tl
    switch (this.stateName) {
        case 'opened':
            this.setOpenAnimation(this.mc, tl, tl2);

            break;

        case 'visible':
            if (this.prevStateName === 'hidden') this.setShowAnimation(this.mc, tl);
            else {
                if (this._tl2) {
                    this._tl2.pause();
                }
                this.setCloseAnimation(this.mc, tl);
            }

            break;

        case 'hidden':
            this.setHideAnimation(this.mc, tl);

            break;
    }

    _onStartTransition(this);
    // tl.resume();

    this._tl = tl;
    this._tl2 = tl2;

    return this;
};

//

//
// OBJECT CONSTRUCTOR:
//
const StoriesDisplay = (params = {}) => {
    let Decoration = new EventEmitter();

    const defaults = {
        id: 'event-0'
    };

    const params2 = Utils.extend(defaults, params);

    const initialProps = {
        initiated: false,
        win: window,
        el: null,
        mc: null,
        domElement: null,
        factory: StoriesFactory(),
        ticker: TweenMax.ticker,
        time: TweenMax.ticker.time,
        prevStateName: 'initial',
        stateName: 'initial',
        params: params2
    };

    Decoration = Utils.extend(Decoration, initialProps);

    // INTERFACE METHODS:
    Decoration.init = (el, centerEl) => init(Decoration, el, centerEl);
    Decoration.destroy = () => destroy(Decoration);
    Decoration.start = () => start(Decoration);
    Decoration.stop = () => stop(Decoration);
    Decoration.render = () => {
        const t = Decoration.ticker.time;
        const dt = t - Decoration.time;
        if (!isNaN(dt) && dt > 0) render(Decoration, dt);
        Decoration.time = t;
        return Decoration;
    };
    Decoration.setState = setState.bind(Decoration);
    // Decoration.setProgress = setProgress.bind(Decoration);

    return Decoration;
};

export {StoriesDisplay};
export default StoriesDisplay;
